import React from 'react'
import './LiveMeetings.scss'

export interface LiveBadgeProps {
  startedAt: string
  finishedAt?: string
}

export const LiveBadge: React.FC<LiveBadgeProps> = ({ startedAt, finishedAt }) => {
  return !finishedAt || new Date(startedAt).getTime() <= Date.now() ? (
    <div className='d-flex align-items-center align-content-center p-1 zocks-border-danger-background zocks-border-0.25 zocks-text-danger zocks-bg-color-danger-background gap-2'>
      <span className='button-small'>Live</span>
    </div>
  ) : null
}
